import axios from "axios";
import {utilityServicesPath} from "../../Constants";

const restUrl = utilityServicesPath + '/organizations/pictures'

export default class UtilityServiceOrganizationPictures {

    static async get(pictureSystemType, page, pageSize, search) {
        const params = {
            page: page,
            pageSize: pageSize,
            search: search,
            pictureSystemType: pictureSystemType
        };
        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return axios.get(`${restUrl}?${queryString}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getByCompositionMediaId(compositionMediaId) {
        return axios.get(restUrl + `/by-composition-media-id?compositionMediaId=${compositionMediaId}`);
    }

    /** GET …/by-textured → PictureDto[] */
    static async getAllTextured() {
        return axios.get(`${restUrl}/by-textured`, {
            headers: {
                Accept: 'application/json',
            },
        });
    }

    /** GET …/by-textured/by-ids?ids=1&ids=2 → PictureDto[] */
    static async getTexturedByIds(ids) {
        const unique = [...new Set(
            (Array.isArray(ids) ? ids : [])
                .map((id) => Number(id))
                .filter((id) => Number.isFinite(id) && id !== 0),
        )];
        if (unique.length === 0) {
            return {data: []};
        }
        return axios.get(`${restUrl}/by-textured/by-ids`, {
            params: {ids: unique},
            paramsSerializer: {indexes: null},
            headers: {
                Accept: 'application/json',
            },
        });
    }

    static async setInCompositionMediaId(values, compositionMediaId) {
        return axios.patch(`${restUrl}/${values.selectedString?.id}/set-in-composition-media?compositionMediaId=${compositionMediaId}&priority=${values.priority}`, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteInCompositionMediaId(id, compositionMediaId) {
        return axios.patch(`${restUrl}/${id}/delete-in-composition-media?compositionMediaId=${compositionMediaId}`, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${restUrl}/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}
